'use client';

import { usePathname } from 'next/navigation';
import { SiteShell } from '@/platform/layout/SiteShell';
import { useAuth } from './useAuth';
import { LoginLink } from './LoginLink';

type Props = {
  children: React.ReactNode;
  message?: string;
};

/** Renders children when signed in; otherwise login CTA with returnTo. */
export function AuthGuard({ children, message = 'Sign in to continue.' }: Props) {
  const { user } = useAuth();
  const pathname = usePathname();

  if (user) {
    return <>{children}</>;
  }

  const returnTo = pathname || '/';
  return (
    <SiteShell title="Sign in required">
      <div className="feed-card settings-page auth-guard">
        <p>{message}</p>
        <LoginLink className="btn btn-primary" returnTo={returnTo}>
          Sign in
        </LoginLink>
      </div>
    </SiteShell>
  );
}
